// TB-109: session reads that several components ask for on the same page
// (get-profile, unread-count, appointments/stats, invoice/pendings) are fetched
// once and shared: concurrent callers get the same request, and the answer is
// reused for a few seconds. Any successful write clears it (see axios.js).

const DEFAULT_TTL_MS = 10000
const store = new Map()

function tokenTail () {
  try { return (localStorage.getItem('accessToken') || '').slice(-16) } catch (e) { return '' }
}

export function sharedKey (url, config = {}) {
  const params = config && config.params ? JSON.stringify(config.params) : ''
  return `${tokenTail()}|${url}|${params}`
}

/** GET through `client` (an axios instance), shared by URL + params + session. Resolves the axios response. */
export function sharedGet (client, url, config = {}, { ttl = DEFAULT_TTL_MS, now = Date.now } = {}) {
  const key = sharedKey(url, config)
  const hit = store.get(key)
  if (hit && (hit.pending || now() - hit.at < ttl)) return hit.promise
  const entry = { at: 0, pending: true, promise: null }
  entry.promise = Promise.resolve()
    .then(() => client.get(url, config))
    .then((res) => {
      entry.pending = false
      entry.at = now()
      return res
    }, (err) => {
      if (store.get(key) === entry) store.delete(key)
      throw err
    })
  store.set(key, entry)
  return entry.promise
}

// TB-117: lookups (consultation types, purposes of consultation) barely change:
// one read per session for 10 minutes, still dropped after any write.
const LOOKUP_TTL_MS = 10 * 60 * 1000

export function lookupGet (client, url, config = {}) {
  return sharedGet(client, url, config, { ttl: LOOKUP_TTL_MS })
}

export function clearSharedGets () {
  store.clear()
}

/** True for a request that changes data (book, cancel, complete, schedule edits...). */
const READ_POSTS = /\/(search|login|suggestions)(\?|$)/

// TB-117: POST /providers, /user and /loved-ones/all with only id lists are batch
// lookups; treating them as writes emptied every cache on each list screen.
const LOOKUP_POSTS = /\/(providers|user|loved-ones\/all)$/
const LOOKUP_BODY = /"(providerIds|patientIds|lovedOneIds)"/

export function isWrite (config) {
  const m = String((config && config.method) || 'get').toLowerCase()
  if (m === 'get' || m === 'head' || m === 'options') return false
  const url = String((config && config.url) || '').split('?')[0]
  if (READ_POSTS.test(url)) return false
  if (LOOKUP_POSTS.test(url)) {
    const body = config.data
    const text = typeof body === 'string' ? body : (() => { try { return JSON.stringify(body || {}) } catch (e) { return '' } })()
    if (LOOKUP_BODY.test(text) && !/"(?!providerIds|patientIds|lovedOneIds)[^"]+"\s*:/.test(text)) return false
  }
  return true
}
